import { Button, Stack, Typography } from '@mui/material';
import { IconCollapse } from 'app/components/elements/icons/IconCollapse';
import { TextEllipsis } from 'app/components/elements/TextEllipsis';
import { PhotoPreviewGroup } from 'app/components/elements/PhotoPreviewThumbnail';
import { getParentNameByLevel } from 'app/pages/ReportPage';
import { AssetIssues } from 'types/room';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';

type RenderDataMapProps = {
  indexActive?: number;
  dataAssetValidation: AssetIssues[];
  onCollapse: ({ value, indexRow }: { value: AssetIssues; indexRow: number }) => void;
  onViewIssues: (value: AssetIssues) => void;
  onCreateNewIssue: (value: AssetIssues) => void;
  onClickRoom: (value?: { key: string; value: string; label: string; level?: number }) => void;
  keySearch?: { key: string; value: string; label: string; level?: number }[];
  onPreview: (value: AssetIssues) => void;
  onGenerateReport: (value: AssetIssues) => void;
  isCanAction?: boolean;
  onArchive: (value: AssetIssues) => void;
  onGenerateSingleAsset?: (value: AssetIssues) => Promise<void>;
};
export const renderDataAssetValidation = ({
  dataAssetValidation,
  onCollapse,
  onViewIssues,
  onCreateNewIssue,
  indexActive,
  onClickRoom,
  keySearch,
  onGenerateReport,
  onGenerateSingleAsset,
  onArchive,
  isCanAction
}: RenderDataMapProps) => {
  const checkIsFilter = (key: string) => {
    return !!keySearch?.find((item) => item.key === key);
  };
  return dataAssetValidation.map((data, index) => {
    const room = data.room;
    const isHasIssueIsNotRepaired = data.issueReports.some((issue) => issue.status === 'ACTIVE');

    return {
      name: {
        value: (
          <TextEllipsis
            onClick={() => {
              data.name &&
                onClickRoom({
                  value: data.name,
                  label: data.name,
                  key: 'name'
                });
            }}
            text={data.name}
            width={'95%'}
            active={checkIsFilter('name')}
          />
        )
      },
      clientName: {
        value: (
          <TextEllipsis
            onClick={() => {
              onClickRoom({
                value: data?.room.client.id.toString(),
                label: data?.room?.client?.clientName,
                key: 'clientId'
              });
            }}
            text={data?.room?.client?.clientName}
            width={'95%'}
            active={checkIsFilter('clientId')}
          />
        )
      },
      mainLocation: {
        value: (
          <TextEllipsis
            onClick={() => {
              onClickRoom({
                value: getParentNameByLevel(room, 1)?.id.toString() || '',
                label: getParentNameByLevel(room, 1)?.name || '',
                key: 'locationId',
                level: 1
              });
            }}
            text={getParentNameByLevel(room, 1)?.name || ''}
            width={'95%'}
            active={!!keySearch?.find((item) => item.key === 'locationId' && item.level === 1)}
          />
        )
      },
      subLocation1: {
        value: (
          <TextEllipsis
            onClick={() => {
              onClickRoom({
                value: getParentNameByLevel(room, 2)?.id.toString() || '',
                label: getParentNameByLevel(room, 2)?.name || '',
                key: 'locationId',
                level: 2
              });
            }}
            text={getParentNameByLevel(room, 2)?.name || ''}
            width={'95%'}
            active={!!keySearch?.find((item) => item.key === 'locationId' && item.level === 2)}
          />
        )
      },
      subLocation2: {
        value: (
          <TextEllipsis
            onClick={() => {
              onClickRoom({
                value: getParentNameByLevel(room, 3)?.id.toString() || '',
                label: getParentNameByLevel(room, 3)?.name || '',
                key: 'locationId',
                level: 3
              });
            }}
            active={!!keySearch?.find((item) => item.key === 'locationId' && item.level === 3)}
            text={getParentNameByLevel(room, 3)?.name || ''}
            width={'95%'}
          />
        )
      },
      verticalLevel: {
        value: (
          <TextEllipsis
            onClick={() => {
              onClickRoom({
                value: data?.room.parent.id.toString(),
                label: data?.room.parent.name,
                key: 'locationId',
                level: 4
              });
            }}
            text={getParentNameByLevel(room, 4)?.name || ''}
            width={'95%'}
            active={!!keySearch?.find((item) => item.key === 'locationId' && item.level === 4)}
          />
        )
      },
      room: {
        value: (
          <Stack alignItems={'center'} gap={2.5}>
            <TextEllipsis
              onClick={() => {
                onClickRoom({
                  value: data?.room.id.toString(),
                  label: data?.room.name,
                  key: 'locationId',
                  level: 5
                });
              }}
              text={getParentNameByLevel(room, 5)?.name || ''}
              width={'95%'}
              active={!!keySearch?.find((item) => item.key === 'locationId' && item.level === 5)}
            />
            <Link
              to={`/clients/${data?.room?.client?.clientName}/${data?.room?.client?.id}/location/${getParentNameByLevel(room, 5)?.id}/room`}
              style={{ textDecoration: 'none', color: 'inherit', width: '95%' }}>
              <TextEllipsis
                text={'View Location'}
                width={'100%'}
                active={!!keySearch?.find((item) => item.key === 'locationId' && item.level === 5)}
                styles={{ color: '#226AAA', fontWeight: 700, textDecoration: 'underline' }}
              />
            </Link>
          </Stack>
        )
      },
      type: {
        value: (
          <TextEllipsis
            onClick={() => {
              data?.type?.name &&
                onClickRoom({
                  value: data.type?.id.toString(),
                  label: data.type?.name,
                  key: 'typeId'
                });
            }}
            text={data?.type?.name}
            width={'95%'}
            styles={{
              fontWeight: checkIsFilter('typeId') ? 700 : 400,
              backgroundColor: checkIsFilter('typeId') ? 'rgba(0,0,0,0.2)' : 'unset'
            }}
          />
        )
      },
      hasIssue: {
        value: (
          <TextEllipsis
            onClick={() => {
              onClickRoom({
                value: data.issueReports.length > 0 && isHasIssueIsNotRepaired ? 'true' : 'false',
                label: data.issueReports.length > 0 && isHasIssueIsNotRepaired ? 'Yes' : 'No',
                key: 'hasIssue'
              });
            }}
            text={data.issueReports.length > 0 && isHasIssueIsNotRepaired ? 'Yes' : 'No'}
            width={'95%'}
            active={checkIsFilter('hasIssue')}
            inputStyle={{
              color: data.issueReports.length > 0 && isHasIssueIsNotRepaired ? '#DD0808' : '#23C33B'
            }}
          />
        )
      },
      model: {
        value: (
          <TextEllipsis
            onClick={() => {
              onClickRoom({
                value: data.model.id.toString(),
                label: data.model.name,
                key: 'modelId'
              });
            }}
            text={data.model.name}
            width={'95%'}
            active={checkIsFilter('modelId')}
          />
        )
      },
      validated: {
        value: (
          <TextEllipsis
            onClick={() => {
              onClickRoom({
                value: data.validated ? 'true' : 'false',
                label: data.validated ? 'Yes' : 'No',
                key: 'validated'
              });
            }}
            text={data.validated ? 'Yes' : 'No'}
            width={'95%'}
            active={checkIsFilter('validated')}
            inputStyle={{ color: data.validated ? '#4CAF50' : '#F44336' }}
          />
        )
      },
      attributes: {
        value: (
          <Button
            onClick={() => onCollapse({ value: data, indexRow: index })}
            style={{ flexDirection: 'row', gap: '10px' }}>
            <IconCollapse color={'#226AAA'} direction={indexActive === index ? 'up' : 'down'} />
            <Typography style={{ color: '#226AAA', fontSize: '14px', fontWeight: 700 }}>
              {indexActive === index ? 'Collapse' : 'Expand'}
            </Typography>
          </Button>
        )
      },
      createdAt: {
        value: (
          <TextEllipsis text={dayjs(data.createdAt).format('YYYY-MM-DD HH:mm')} width={'95%'} />
        )
      },
      updatedAt: {
        value: (
          <TextEllipsis text={dayjs(data.updatedAt).format('YYYY-MM-DD HH:mm')} width={'95%'} />
        )
      },
      photo: {
        value:
          data?.photos?.length > 0 ? (
            <PhotoPreviewGroup
              photos={
                data.photos[0]
                  ? [
                      {
                        src: data.photos[0].url,
                        alt: 'asset-photo-0',
                        key: data.photos[0].id ?? 0
                      }
                    ]
                  : []
              }
              thumbnailWidth={72}
              thumbnailHeight={72}
            />
          ) : null
      },
      action: {
        value: (
          <Stack gap={1} alignItems={'flex-start'} justifyContent={'flex-start'}>
            {isCanAction && (
              <Button
                onClick={() => {
                  onArchive(data);
                }}>
                <Typography style={{ color: '#226AAA', fontSize: '14px', fontWeight: 700 }}>
                  Archive
                </Typography>
              </Button>
            )}
            {isCanAction && (
              <Button
                onClick={() => {
                  onCreateNewIssue(data);
                }}>
                <Typography style={{ color: '#226AAA', fontSize: '14px', fontWeight: 700 }}>
                  Create New Issue
                </Typography>
              </Button>
            )}
            {data.issueReports.length > 0 && isCanAction && (
              <Button
                onClick={() => {
                  onViewIssues(data);
                }}>
                <Typography style={{ color: '#226AAA', fontSize: '14px', fontWeight: 700 }}>
                  {isHasIssueIsNotRepaired
                    ? `Current Issue${data.issueReports.length > 1 ? 's' : ''}`
                    : 'Nonactive Issue'}
                </Typography>
              </Button>
            )}
            {onGenerateSingleAsset && (
              <Button onClick={() => onGenerateSingleAsset(data)}>
                <Typography style={{ color: '#226AAA', fontSize: '14px', fontWeight: 700 }}>
                  Single Asset PDF
                </Typography>
              </Button>
            )}
            {/*<Button*/}
            {/*  onClick={() => {*/}
            {/*    onPreview(data);*/}
            {/*  }}>*/}
            {/*  <Typography style={{ color: '#226AAA', fontSize: '14px', fontWeight: 700 }}>*/}
            {/*    Preview PDF*/}
            {/*  </Typography>*/}
            {/*</Button>*/}
            <Button
              onClick={() => {
                onGenerateReport(data);
              }}>
              <Typography style={{ color: '#226AAA', fontSize: '14px', fontWeight: 700 }}>
                Generate Report
              </Typography>
            </Button>
          </Stack>
        )
      }
    };
  });
};
